'use client';

import { Box, Skeleton } from '@chakra-ui/react';

const BannerSkeleton = () => {
  return (
    <Box w="full" px="4">
      <Skeleton h="130px" w="full" maxWidth="508px" mx="auto" rounded="xl" />
    </Box>
  );
};

export default BannerSkeleton;
